<style scoped>
    th, td {
        text-align: center;
    }
</style>

<template>
    <div class="component-container">
        <input type="hidden" name="work_history_data" :value="yearJson">
        <table class="table table-striped table-bordered">
            <thead>
                <tr>
                    <th style="width: 10%"></th>
                    <th style="width: 45%">&nbsp;</th>
                    <th v-for="yearData in workData" :key="yearData.alumni_year">
                        {{obligationStartMonth}} {{yearData.calendar_year}}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td colspan="2" class="text-left">
                        <span style="font-size: bigger; font-weight: bold">Global Responses</span>
                        <div class="indent">
                            <strong>None of the below</strong>
                            <br>
                             (I was in a different state and not in an underserved area or one of these special settings.)
                         </div>
                    </td>
                    <td v-for="yearData in workData" :key="'none_of_below-'+yearData.alumni_year">
                        <input v-model="yearData.none_of_below" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="text-left">
                        <strong class="indent">I was not working.</strong>
                    </td>
                    <td v-for="yearData in workData" :key="'not_working-'+yearData.alumni_year">
                        <input v-model="yearData.not_working" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td colspan="100%" class="text-left">
                        <div class="indent">
                            <strong>I was still working in:</strong>
                            <em>(check all that apply)</em>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="text-right" colspan="2">
                        the {{practiceName}}
                    </td>
                    <td v-for="yearData in workData" :key="'still_at_practice-'+yearData.alumni_year">
                        <input v-model="yearData.still_at_practice" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right" colspan="2">
                        the same organization but at a different site
                    </td>
                    <td v-for="yearData in workData" :key="'atDifferentSite-'+yearData.alumni_year">
                        <input v-model="yearData.at_different_site" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="text-left">
                        <strong>I was still working in {{practiceState}}</strong>
                    </td>
                    <td v-for="yearData in workData" :key="'still_in_state-'+yearData.alumni_year">
                        <input v-model="yearData.still_in_state" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="text-left">
                        <strong>I was in a Federal Health Professional Shortage Area (HPSA)</strong>
                    </td>
                    <td v-for="yearData in workData" :key="'hpsa'+yearData.alumni_year">
                        <input v-model="yearData.hpsa" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="text-left">
                        <strong>I was in a state-designated shortage area</strong>
                    </td>
                    <td v-for="yearData in workData" :key="'shortageArea-'+yearData.alumni_year">
                        <input v-model="yearData.shortage_area" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td colspan="100%" class="text-left">
                        <strong>I was working in a special type of practice:</strong>
                        <em>(check all that apply)</em>
                    </td>
                </tr>
                <tr>
                    <td rowspan="5" class="text-left align-middle">Federally Designated</td>
                    <td class="text-right">
                        Federally Qualified Health Center (FQHC)
                    </td>
                    <td v-for="yearData in workData" :key="'fqhc-'+yearData.alumni_year">
                        <input v-model="yearData.fqhc" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        Migrant Health Center (MHC)
                    </td>
                    <td v-for="yearData in workData" :key="'mhc-'+yearData.alumni_year">
                        <input v-model="yearData.mhc" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        IHS Clinic or Hospital
                    </td>
                    <td v-for="yearData in workData" :key="'ihs-'+yearData.alumni_year">
                        <input v-model="yearData.ihs" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        Rural Health Clinic
                    </td>
                    <td v-for="yearData in workData" :key="'rural'+yearData.alumni_year">
                        <input v-model="yearData.rural" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        Critical Access Hospital
                    </td>
                    <td v-for="yearData in workData" :key="'criticalAccess-'+yearData.alumni_year">
                        <input v-model="yearData.critical_access" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td colspan="100%">&nbsp;</td>
                </tr>
                <tr>
                    <td rowspan="7" class="text-left align-middle">Not Federally Designated</td>
                    <td class="text-right">
                        Community Health Center — (NOT federally designated)
                    </td>
                    <td v-for="yearData in workData" :key="'healthCenter-'+yearData.alumni_year">
                        <input v-model="yearData.health_center" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        Tribal clinic; urban Indian clinic
                    </td>
                    <td v-for="yearData in workData" :key="'tribalClinic-'+yearData.alumni_year">
                        <input v-model="yearData.tribal_clinic" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        Correctional facility
                    </td>
                    <td v-for="yearData in workData" :key="'correctional-'+yearData.alumni_year">
                        <input v-model="yearData.correctional" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        Health department
                    </td>
                    <td v-for="yearData in workData" :key="'healthDepartment-'+yearData.alumni_year">
                        <input v-model="yearData.health_department" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        Community mental health facility
                    </td>
                    <td v-for="yearData in workData" :key="'communityMentalHealth-'+yearData.alumni_year">
                        <input v-model="yearData.community_mental_health" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        Other special site - describe: <input type="text" :value="typeOtherTxt1" name="TypeOtherTxt1">
                    </td>
                    <td v-for="yearData in workData" :key="'other1-'+yearData.alumni_year">
                        <input v-model="yearData.other1" type="checkbox">
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        Other special site - describe: <input type="text" :value="typeOtherTxt2" name="TypeOtherTxt2">
                    </td>
                    <td v-for="yearData in workData" :key="'other2-'+yearData.alumni_year">
                        <input v-model="yearData.other2" type="checkbox">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import moment from 'moment';

    var YearDataHandler = {
        set: function (obj, prop, value) {
            switch (prop) {
                case 'none_of_below':
                case 'not_working':
                    Object.keys(obj)
                        .filter(key => (key != 'alumni_year' && key != 'calendar_year' && key != prop))
                        .forEach(key => {
                            obj[key] = false;
                        });
                    break;
                case 'still_at_practice':
                    obj.still_in_state = true;
                default:
                    obj.none_of_below = false;
                    obj.not_working = false;
                    break;
            }
            obj[prop] = value;

            return true;
        }
    }
    class YearData {
        constructor (alumniYear, calendarYear) {
            this.alumni_year = alumniYear;
            this.calendar_year = calendarYear;
            this.none_of_below = false;
            this.not_working = false;
            this.still_at_practice = false;
            this.at_different_site = false;
            this.still_in_state = false;
            this.hpsa = false;
            this.shortage_area = false;
            this.fqhc = false;
            this.mhc = false;
            this.ihs = false;
            this.rural = false;
            this.critical_access = false;
            this.health_center = false;
            this.tribal_clinic = false;
            this.correctional = false;
            this.health_department = false;
            this.community_mental_health = false;
            this.other1 = false;
            this.other2 = false;
        }
    }

    export default {
        components: {},
        props: {
            obligationEndDate: {
                type: String,
                required: true
            },
            dataCollectionYears: {
                type: Array,
                required: true
            },
            responseData: {
                required: true
            },
            practiceName: {
                required: true,
                type: String
            },
            practiceState: {
                required: true,
                type: String
            },
            typeOtherTxt1: {
                required: true,
            },
            typeOtherTxt2: {
                required: true,
            }
        },
        data() {
            return {
                showYear2: true,
                showYear3: false,
                workData: {}
            }
        },
        computed: {
            obligationStartMonth: function () {
                return this.obligationEndDateObj.format('MMMM');
            },
            yearJson: function () {
                return JSON.stringify(this.workData)
            },
            obligationEndDateObj: function () {
                return moment(this.obligationEndDate);
            },
            workDataYears: function () {
                return this.workData.map(yearData => yearData.alumni_year);
            }
        },
        methods: {
            calculateCalendarYear (yearData) {
                yearData.calendar_year = parseInt(this.obligationEndDateObj.format('YYYY'))+yearData.alumni_year
                return yearData
            },
            assembleWorkData() {
                let responseData = this.responseData || '[]';
                this.workData = JSON.parse(responseData)
                                    .filter(yearData => this.dataCollectionYears.includes(yearData.alumni_year))
                                    .map(yearData => {
                                        yearData = this.calculateCalendarYear(yearData)
                                        return new Proxy(yearData, YearDataHandler)
                                    });

                this.dataCollectionYears
                    .filter(alumniYear => {
                        return !this.workDataYears.includes(alumniYear)
                    })
                    .forEach(alumniYear => {
                        this.workData.push(new Proxy(new YearData(alumniYear, this.obligationEndDateObj.year()+alumniYear), YearDataHandler))
                    })
            },
        },
        mounted () {
            this.assembleWorkData();
        }
    }
</script>